export default {
  //MEDIA_ROOT_URL: "https://schoolroomhelp.20thfloor.us/",
  //MEDIA_ROOT_URL: "https://schoolroomhelp.20thfloor.com/",
 MEDIA_ROOT_URL: "https://schoolroomhelp.com/",
};
